import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, map } from 'rxjs/operators'
import { PpwLocalStorageService } from '../../app/common/services/ppwlocalstorage.service'
import { Client, ClientPaginatedList, ClientSearchCriteria } from '../models/client.model'
import { BaseService } from './base.service'

@Injectable({
    providedIn: 'root'
})
export class ClientService extends BaseService {
    get uri(): string {
        return `${this.baseUri}/Clients`
    }

    constructor(private readonly ppwLocalStorageService: PpwLocalStorageService, readonly http: HttpClient) {
        super(http)
    }

    async getClients(clientSearchCriteria: ClientSearchCriteria): Promise<ClientPaginatedList> {
        const preferences = this.ppwLocalStorageService.getStoredData(
            this.ppwLocalStorageService.STORAGE_KEY_PROFILE_PREFERENCES
        )
        clientSearchCriteria.includeArchived = preferences && preferences.showArchivedData

        return this.$http
            .get<ClientPaginatedList>(this.uri, { params: clientSearchCriteria.httpParams(), observe: 'response' })
            .pipe(
                map((response) => ClientPaginatedList.fromJSON(this.preCheckResponseData(response))),
                catchError(async (err) => this.handleError(err))
            )
            .toPromise()
    }

    async getAllClients(): Promise<ClientPaginatedList> {
        const searchCriteria = new ClientSearchCriteria(1, 100000)

        return this.getClients(searchCriteria)
    }

    async saveClient(client: Client): Promise<Client> {
        const uri = client.id ? `${this.uri}/${client.id}` : this.uri

        if (client.id) {
            return this.$http
                .put<Client>(uri, client, { observe: 'response' })
                .pipe(
                    map((response) => Client.fromJSON(this.preCheckResponseData(response))),
                    catchError(async (err) => this.handleError(err))
                )
                .toPromise()
        }

        return this.$http
            .post<Client>(uri, client, { observe: 'response' })
            .pipe(
                map((response) => Client.fromJSON(this.preCheckResponseData(response))),
                catchError(async (err) => this.handleError(err))
            )
            .toPromise()
    }

    async archiveClient(client: Client): Promise<Client> {
        const uri = `${this.uri}/${client.id}`

        return this.$http
            .delete<Client>(uri, { observe: 'response' })
            .pipe(
                map((response) => Client.fromJSON(this.preCheckResponseData(response))),
                catchError((err) => this.handleError(err))
            )
            .toPromise()
    }
}
